import { Stack, Text, Box, Flex, Button, Divider, SimpleGrid, Link, Badge } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import {
  IAspectsAndTopicsProps,
  ITitleTopics,
  useGetTitlesTopicsData,
} from '../../../../services/hooks/Titles/useGetTitlesTopicsData';
import MessageForUser from '../../../../components/pages/SelectiveProcess/MessageForUser';
import {
  ITitleTypeAndRulesProps,
  useGetTitleTypesAndRules,
} from '../../../../services/hooks/Titles/useGetTitleTypesAndRules';
import { IoMdReturnLeft } from 'react-icons/io';
import FormTitleButton from './FormTitleButton';
import SeeMore from './SeeMore';
import TitleComprovantButton from '../../../../components/PDFs/DownloadPDFButton/TitleComprovantButton';
import { badgeColor } from '../../../../utils/badgeFunction';
import FormDeleteTitleButton from './FormDeleteTitleButton';

interface IOwnProps {
  isMobile?: boolean;
}

const TitlesContentPage: React.FC<IOwnProps> = ({ isMobile }) => {
  const registrationId = useLocation().pathname.split('/')[2];
  const stepId = useLocation().pathname.split('/')[4];
  const getRegistration = useGetRegistration(registrationId);
  const titlesData = useGetTitlesTopicsData<IAspectsAndTopicsProps[]>({
    remove_pagination: true,
    registrationId: registrationId,
    step_id: stepId,
  });

  const navigate = useNavigate();

  const StepTitleTypeList = useGetTitleTypesAndRules<ITitleTypeAndRulesProps>({ step_id: stepId });

  const canSendTopic = (topic: ITitleTopics) => {
    const onPeriod = StepTitleTypeList?.data?.can_send_titles;

    if (!onPeriod) return false;

    if (topic.total_send < topic.qtd_max_title || topic.qtd_max_title_ilimited) {
      return true;
    }

    return false;
  };
  return (
    <Stack px={isMobile ? 0 : 5} pb={10} gap={1}>
      <Stack align={isMobile ? 'flex-start' : 'center'}>
        {!isMobile && (
          <Text fontSize={'medium'} fontWeight={'bold'}>
            PROVA DE TÍTULOS
          </Text>
        )}

        <Text fontSize={isMobile ? 'small' : 'medium'}>
          {getRegistration.data?.selective_process_vacancy?.selective_process?.name}
        </Text>
        <Text
          fontSize={isMobile ? 'small' : 'medium'}
        >{`${getRegistration.data?.registration_code} - ${getRegistration.data?.candidate.user.full_name}`}</Text>
        <Text
          fontSize={isMobile ? 'small' : 'medium'}
        >{`${getRegistration.data?.selective_process_vacancy?.name}`}</Text>
      </Stack>

      <Stack>
        {StepTitleTypeList.data?.orientation_to_send_of_title && (
          <MessageForUser showIcon={false} informationText={StepTitleTypeList.data?.orientation_to_send_of_title} />
        )}
      </Stack>

      <Stack gap={5}>
        {titlesData.data?.map((aspect) => (
          <Stack shadow={'md'} borderRadius={'md'} key={aspect?.id}>
            <Box p={2} bg={'#5a5a5a'} color={'white'} borderRadius={'md'}>
              <Flex gap={1} flexDir={['column', 'column', 'row', 'row', 'row']}>
                <Text fontWeight={'bold'} fontSize={'14px'}>{`${aspect.name}`}</Text>
                <Text fontSize={'12px'}>
                  {!aspect.max_send_qtd_ilimited
                    ? aspect.total_aspect_send === 0
                      ? `Nenhum título enviado de ${aspect.max_send_qtd} permitidos`
                      : `${aspect.total_aspect_send} título${aspect.total_aspect_send > 1 ? 's' : ''} enviado${aspect.total_aspect_send > 1 ? 's' : ''} de ${aspect.max_send_qtd} permitidos`
                    : aspect.total_aspect_send === 0
                      ? 'Nenhum título enviado'
                      : `${aspect.total_aspect_send} título${aspect.total_aspect_send > 1 ? 's' : ''} enviado${aspect.total_aspect_send > 1 ? 's' : ''}`}
                </Text>
              </Flex>
            </Box>

            {aspect.titles_topics.map((topic) => (
              <Box p={1} key={topic?.id} shadow={'base'} borderRadius={'md'}>
                <Box borderRadius={'md'} bg={'#a09e9e'} color={'white'} p={2}>
                  <Flex gap={1} flexDir={['column', 'column', 'row', 'row', 'row']}>
                    <Text fontWeight={'bold'} fontSize={'small'}>{`${topic.name}`}</Text>
                    <Text fontSize={'small'}>
                      {!topic.qtd_max_title_ilimited
                        ? topic.total_send === 0
                          ? `Nenhum título enviado de ${topic.qtd_max_title} permitidos`
                          : `${topic.total_send} título${topic.total_send > 1 ? 's' : ''} enviado${topic.total_send > 1 ? 's' : ''} de ${topic.qtd_max_title} permitidos`
                        : topic.total_send === 0
                          ? 'Nenhum título enviado'
                          : `${topic.total_send} título${topic.total_send > 1 ? 's' : ''} enviado${topic.total_send > 1 ? 's' : ''}`}
                    </Text>
                  </Flex>
                </Box>
                <Stack mb={5}>
                  {topic.total_send == 0 ? (
                    <Text ml={2} mt={2}>
                      Nenhum arquivo enviado nesse tópico
                    </Text>
                  ) : (
                    <SimpleGrid ml={2} mt={2} columns={{ base: 1, md: 3, xl: 3 }} spacing={4}>
                      {topic.titles_send.map((title) => {
                        const colorBadge = badgeColor(title?.status?.name || '');
                        return (
                          <Stack
                            justify={'space-between'}
                            key={title.id}
                            rounded={'md'}
                            w={'100%'}
                            shadow={'base'}
                            p={isMobile ? 2 : 5}
                          >
                            <Stack>
                              {title?.attachements?.map((attach) => (
                                <Box key={attach.id}>
                                  <Link href={attach.url} target="_blank" color={'colorLink'}>
                                    <Text fontSize={'14px'} fontWeight={'semibold'}>
                                      {attach.name}
                                    </Text>
                                  </Link>
                                  <Text fontSize={'small'}>{attach.created_at}</Text>
                                </Box>
                              ))}

                              <Divider />

                              <Stack>
                                {title?.status?.name && (
                                  <Flex gap={1}>
                                    <Text fontWeight={'bold'}>Situação: </Text>
                                    <Badge
                                      bgColor={colorBadge?.bgColor}
                                      color={colorBadge?.color}
                                      px={2}
                                      py={0}
                                      borderRadius="sm"
                                      textTransform="capitalize"
                                      fontSize="small"
                                      w={'fit-content'}
                                    >
                                      {title?.status?.name}
                                    </Badge>
                                  </Flex>
                                )}

                                {title.justification && (
                                  <SeeMore label="Justificativa" key={title.id} observation={title.justification} />
                                )}

                                <Flex gap={1}>
                                  <Text fontWeight={'bold'}>Protocolo: </Text>
                                  <Text>{title.protocol_code}</Text>
                                </Flex>
                                {title?.declared_value && (
                                  <Flex gap={1}>
                                    <Text fontWeight={'bold'}>Declaração do candidato: </Text>
                                    <Text>{title.declared_value}</Text>
                                  </Flex>
                                )}

                                <SeeMore key={title.id} observation={title.observation} />

                                <Stack gap={1}>
                                  <Text>
                                    <strong>Pontuação possível: </strong> {title.total_points_declared_per_title} pontos{' '}
                                  </Text>
                                </Stack>
                              </Stack>
                            </Stack>
                            {StepTitleTypeList.data?.can_send_titles && (
                              <FormDeleteTitleButton refetch={titlesData.refetch} title={title} />
                            )}
                          </Stack>
                        );
                      })}
                    </SimpleGrid>
                  )}
                  {canSendTopic(topic) && (
                    <Flex ml={2} mt={2}>
                      {StepTitleTypeList.data && (
                        <FormTitleButton
                          rules={StepTitleTypeList.data}
                          registrationId={registrationId}
                          stepId={stepId}
                          topic={topic}
                          refetchData={titlesData.refetch}
                        />
                      )}
                    </Flex>
                  )}
                </Stack>
              </Box>
            ))}
          </Stack>
        ))}

        {/* <Stack gap={1}>
                    <Box p={3} bg={'blue.500'} color={'white'} borderRadius={'md'}>
                      <Flex gap={1}>
                        <Text fontWeight={'bold'} fontSize={'small'}>
                          Pontuação
                        </Text>
                      </Flex>
                    </Box>
                    <Box p={5} boxShadow={'md'} borderRadius={'md'}>
                      <Text fontWeight={'bold'}>Pontuação total informada pelo candidato: </Text>
    
                      <UnorderedList>
                        {titlesData.data?.map((aspect) => (
                          <ListItem key={aspect.name}>
                            <Text>
                              {aspect.name}: {aspect.total_points_declared} pontos
                            </Text>
                          </ListItem>
                        ))}
                      </UnorderedList>
    
                      <Text mt={2} fontWeight={'bold'} fontSize={'x-large'}>
                        {titlesData.data?.reduce((acc, aspect) => acc + (Number(aspect.total_points_declared) || 0), 0)}{' '}
                        pontos
                      </Text>
    
                      <Text>
                        A pontuação calculada considera o máximo que o candidato poderá obter com os títulos enviados,
                        observados os limites por tópico e quesito
                      </Text>
                    </Box>
                  </Stack> */}

        <Flex gap={2}>
          <Button
            onClick={() => navigate(-1)}
            w={'fit-content'}
            leftIcon={<IoMdReturnLeft />}
            colorScheme="blue"
            variant={'outline'}
            size={'sm'}
          >
            Voltar
          </Button>
          <TitleComprovantButton mode="print" data={titlesData.data} registrationData={getRegistration.data} />
          {/* <Button w={'fit-content'} leftIcon={<IoPrint />} colorScheme="blue" variant={'outline'}>
                      Imprimir página
                    </Button> */}
        </Flex>
      </Stack>
    </Stack>
  );
};

export default TitlesContentPage;
